import * as React from "react";
import { filterSingleValue } from "../../../../api_calls/TableauVisuals";
import SingleSelect from "../../../../components/commonComponents/Selectors/SingleSelect";
import { useDispatch, useSelector } from "react-redux";
import { checkUserRole } from "../../../../api_calls/userManagement";
import { updateStateData } from "../../../../Store/actions";

export default function AnalysisGroupSingle({ redux_param_name, multiSelect, reduxKeywordToSaveValue }) {
  const userStateData = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [selectedAnalysisGroup, setAnalysisGroup] = React.useState({});
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const userRole = userStateData?.brand_report_view === true ? { user_role: "Brand" } : checkUserRole();
  let adlevelNames =
    typeof userStateData.adlevel_names !== "undefined" && userStateData.adlevel_names.length !== 0
      ? [
        ...userStateData.adlevel_names.map((adlevelInfo) => {
          return adlevelInfo.label;
        }),
      ]
      : [];

  if (userRole.user_role === "Brand") {
    // check brand filter object to fetch stores for brand (selected by retailer)
    adlevelNames = userStateData?.brand_filters?.performance_filter?.analysis_group
      ? multiSelect
        ? [...userStateData.brand_filters.performance_filter.analysis_group]
        : [...userStateData.brand_filters.performance_filter.analysis_group].filter((item) => item !== "(All)")
      : [];
  }

  // selected values for analysis group
  const selectedValues = typeof userStateData[reduxKeywordToSaveValue] !== "undefined" && typeof userStateData[reduxKeywordToSaveValue][redux_param_name] !== "undefined" ? userStateData[reduxKeywordToSaveValue][redux_param_name] : adlevelNames

  const selectAnalysisGroupValues = (option) => {
    setAnalysisGroup({ value: option.value, label: option.value });
  };

  React.useEffect(() => {
    let defaultSelection = selectedValues.length !== 0 ? selectedValues[0] : "";
    setAnalysisGroup({ value: defaultSelection, label: defaultSelection });
    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
  }, [userRole.user_role]);

  return dataLoaded ? (
    <SingleSelect
      enableFullWidth={true}
      label={"Analysis Group"}
      sortOptions={false}
      selectionCheck={(option, value) => option.label === value.label}
      options={adlevelNames.map((groupName) => {
        return { value: groupName, label: groupName };
      })}
      defaultVal={selectedAnalysisGroup}
      onChangeCall={(selectedOption) => {
        let selectAdlevels = [];
        selectAnalysisGroupValues(selectedOption);
        if (selectedOption.value.includes("(All)")) {
          selectAdlevels = adlevelNames;
        } else {
          selectAdlevels = [selectedOption.value];
        }
        // save value to redux
        dispatchAction(
          updateStateData({
            [reduxKeywordToSaveValue]: {
              ...userStateData[reduxKeywordToSaveValue],
              [redux_param_name]: selectAdlevels,
            },
          })
        );
      }}
    />
  ) : (
    <></>
  );
}
